/**
 * Compiles a search layout into the keys the list's search box matches typed text against.
 *
 * A layout with no keys leaves nothing to search, so the page hides the box rather than showing one
 * that filters nothing.
 *
 * @param {Array} layout - The keys the search box matches, in order.
 *
 * @returns {Array}
 */
export const resolveSearchKeys = (layout) =>
  (layout ?? []).map(({ key }) => key).filter(Boolean);

export default resolveSearchKeys;
